import { API } from '~apis/axios/instance';
import { TransactionsMemoModel } from '~models/transactions/memos';
import { ResponseBaseWithData } from '~types/response';

export interface TransactionIdentifier {
  companyId: string;
  transactionId: number;
}

export interface MemoIdentifier extends TransactionIdentifier {
  memoId: number;
}

export const getTransactionMemos = ({ companyId, transactionId }: TransactionIdentifier) => {
  return API.get<ResponseBaseWithData<TransactionsMemoModel.ListResponse>>(
    `/api/v2/companies/${companyId}/labelling/transactions/${transactionId}/memos`,
  );
};

export const createTransactionMemo = ({
  companyId,
  transactionId,
  request,
}: TransactionIdentifier & { request: TransactionsMemoModel.CreateRequest }) => {
  return API.post(`/api/v2/companies/${companyId}/labelling/transactions/${transactionId}/memos`, {
    data: request,
  });
};

export const updateTransactionMemo = ({
  companyId,
  transactionId,
  memoId,
  request,
}: MemoIdentifier & { request: TransactionsMemoModel.UpdateRequest }) => {
  return API.patch(
    `/api/v2/companies/${companyId}/labelling/transactions/${transactionId}/memos/${memoId}/content`,
    { data: request },
  );
};

export const deleteTransactionMemo = ({ companyId, transactionId, memoId }: MemoIdentifier) => {
  return API.delete(
    `/api/v2/companies/${companyId}/labelling/transactions/${transactionId}/memos/${memoId}`,
  );
};
